import { getActiveButtonActions } from "../../../redux/reducers/button";
import FormControl from "../../atom/FormControl";
import Table, { TBody, THead } from "../../common/table/Table";
import { useEffect, useRef, useState } from "react";
import { getDateWithHyphen } from "../../../lib/converting-func";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { RootReducer } from "../../../redux/reducers";
import * as buttonActions from '../../../redux/actions/button';
import client from "../../../axios";
import { useReactToPrint } from "react-to-print";
import styled from "styled-components";
import SelectChoiceModal from "./modals/SelectChoiceModal";
import ListModal from "./modals/ListModal";
import GraphModal from "./modals/GraphModal";
import SplitDateInput from "../../atom/SplitDateInput";

const columns = [
  { name: '날짜', key: 'date' },
  { name: '측정기기', key: 'type' },
  { name: '회차', key: 'attempt' },
  { name: '측정시작시각', key: 'startTime' },
  { name: '시작시 온도', key: 'startTemp' },
  { name: '측정종료시각', key: 'endTime' },
  { name: '종료시온도', key: 'endTemp' },
  { name: '결과/시간', key: 'totalDuration' },
  { name: '적합', key: 'pass' },
  { name: '부적합', key: 'fail' }
];

const Title = styled.div`
    display: none;
      
    @media print {
        display: flex;
        justify-content: center;
        margin: 2rem 0;
    }
  `;

const getToday = () => {
  const date = new Date();
  return `${date.getFullYear()}-${('0' + (date.getMonth() + 1)).slice(-2)}-${('0' + date.getDate()).slice(-2)}`;
}

export default function Temperature() {
  const [start, setStart] = useState(getToday());
  const [end, setEnd] = useState(getToday());
  const [data, setData] = useState<any[]>([]);
  const [detailData, setDetailData] = useState<any[]>([]);
  const [showSelectMode, setShowSelectMode] = useState(false);
  const [radioValue, setRadioValue] = useState('list');

  const [openListModal, setOpenListModal] = useState(false);
  const [openGraphModal, setOpenGraphModal] = useState(false);

  const [selectedRow, setSelectedRow] = useState<Record<string, unknown> | null>(null);

  const btnActions = useSelector((state: RootReducer) => getActiveButtonActions(state, 'temperature'), shallowEqual);
  const dispatch = useDispatch();

  const componentRef = useRef<HTMLDivElement>(null);

  async function getData() {
    const res = await client.get('/api/temperature', {
      params: { start, end }
    });
    setData(res.data);
  }

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `온도기록부_${getDateWithHyphen()}`,
    onAfterPrint: () => console.log("인쇄 완료")
  })

  const handleClickOnRow = (row: Record<string, unknown>) => {
    setSelectedRow(row);
    setShowSelectMode(true);
  }

  useEffect(() => {
    if (btnActions.active && btnActions.action === 'search') {
      getData().then();
      dispatch(buttonActions.clear());
    } else if (btnActions.active && btnActions.action === 'print') {
      handlePrint();
      dispatch(buttonActions.clear());
    }
  }, [btnActions.action, btnActions.active, dispatch]);

  return (
    <div className="px-4 py-3">
      <div className="d-flex gap-3 mb-3 px-4">
        <div className="d-flex gap-2">
          <label className="d-flex align-items-center">시작</label>
          <SplitDateInput 
            value={start} 
            onChange={setStart} 
          />
        </div>
        <div className="d-flex gap-2">
          <label className="d-flex align-items-center">종료</label>
          <SplitDateInput 
            value={end} 
            onChange={setEnd} 
          />
        </div>
      </div>
      <div ref={componentRef} className="px-4">
        <Title>
          <h1>온도기록부</h1>
        </Title>
        <Table>
          <THead>
            <tr>
              {columns.map((value, index) => (
                <th className='text-center' key={index}>{value.name}</th>
              ))}
            </tr>
          </THead>
          <TBody>
            {data.map((row) => (
              <tr key={row.attempt} onClick={() => handleClickOnRow(row)}>
                {columns.map((col) =>
                  <td key={col.key} className='text-center'>
                    {row[col.key] ?? ''}
                  </td>
                )}
              </tr>
            ))}
          </TBody>
        </Table>

        <SelectChoiceModal
          show={showSelectMode}
          setShow={setShowSelectMode}
          selected={radioValue}
          setSelected={setRadioValue}
          setOpenListModal={setOpenListModal}
          setOpenGraphModal={setOpenGraphModal}
          selectedRow={selectedRow}
          setDetailData={setDetailData}
        />

        <ListModal data={detailData} show={openListModal} setShow={setOpenListModal} selectedRow={selectedRow} />
        <GraphModal data={detailData} show={openGraphModal} setShow={setOpenGraphModal} selectedRow={selectedRow} />

      </div>
    </div>
  );
}
